import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { verifyEmail } from '@digiwedge/idp-client';
import { ContentWrap } from '../components/ContentWrap.js';
import { PageContent } from '../components/PageContent.js';
import { Text, Heading } from '../components/index.js';
import { getMessage } from '../i18n/messages.js';
import { toast } from '../utils/toast.js';
export const EmailVerificationPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');
    useEffect(() => {
        if (!token)
            return;
        async function verify(currentToken) {
            try {
                await verifyEmail({ token: currentToken });
                toast.success('Email verified');
                setStatus('success');
                navigate('/login');
            }
            catch {
                toast.error(getMessage('en-US', 'createError'));
                setStatus('error');
            }
        }
        verify(token);
    }, [token, navigate]);
    let content;
    if (status === 'loading')
        content = _jsx(Text, { children: "Verifying..." });
    else if (status === 'success')
        content = _jsx(Text, { children: "Email verified!" });
    else
        content = _jsx(Text, { children: "Verification failed." });
    return (_jsx(PageContent, { children: _jsxs(ContentWrap, { className: "py-16 flex flex-col items-center gap-6", maxWidth: "lg", children: [_jsx(Heading, { variant: "h2", children: "Verify Email" }), content] }) }));
};
//# sourceMappingURL=EmailVerificationPage.js.map